import { MutationTree } from 'vuex';

import { subscribableStore } from './common';
import { TracksGpsState } from './types';

const mutations: MutationTree<TracksGpsState> = {
  ...subscribableStore.mutations,
};

export default mutations;
